import React from 'react'

import { PageWrapper } from './style'
import { HttpError } from 'Components/Page/HttpError'
import { PATHS } from 'Config/Routing/paths'

const NotFound = ({ history }) => (
  <PageWrapper>
    <HttpError
      code={404}
      title="Resource not found."
      message={
        "It looks like you're lost...\nThe page you are looking for no longer exists."
      }
      link={PATHS.main.dashboard}
      history={history}
    />
  </PageWrapper>
)
export { NotFound }



// WEBPACK FOOTER //
// ./src/Components/Page/NotFound/index.js